// extracted by mini-css-extract-plugin
module.exports = {"sortableItem":"style-module_sortableItem__QzIcpU6blDOOQzzDCVQYT","name":"style-module_name__2ucISfaKNaBY98WVvL-jGV"};